import * as Actions from 'store/actions/app/sales.actions'
import { toggleIdInArray } from 'utils/toggle-id-in-array'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'

const initialState = {
  loading_sales: false,
  sales: [],
  total_sales: 0,

  loading_accounting_sales: false,
  accounting_sales: [],
  totals_accounting_sales: null,

  loading_sale: false,
  sale: null,

  saving_sale: false,
  saved_sale: false,
  saved_sale_data: null,

  updating_sale: false,
  updated_sale: false,

  finishing_sale_ids: [],
  finished_sale_ids: [],

  voiding_sale_ids: [],
  voided_sale_ids: [],

  saving_pre_sale_as_order_or_proforma: false,
  saved_pre_sale_as_order_or_proforma: false,

  types_payments: [],
  payment_forms: [],
  series: [],
  correlativo: {},
  coin_types: [],
  price_dollar: null,

  loading_sales_by_seller: false,
  sales_headers_by_seller: null,
  sales_items_by_seller: null,
  quantity_sales_headers_by_seller: 0,
  quantity_sales_items_by_seller: 0,
  amount_sales_headers_by_seller: 0,
  amount_sales_items_by_seller: 0,

  downloading_sales_by_seller: false,

  persons_credits: null,
  credits_by_person: [],
  sale_credit_true: null,
  saved_credit: false,

  saved_pay_of_credit: false,

  payments_person_of_credit: [],
  loading_pp_of_credit: false,

  is_cancel_pay_of_credit: false,
  is_cancel_credit: false
}

const salesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_SALES: {
      return {
        ...state,
        loading_sales: action.payload.loading ?? state.loading_sales,
        sales: action.payload.items ?? state.sales,
        total_sales: action.payload.total ?? state.total_sales,
      }
    }
    case Actions.GET_ACCOUNTING_SALES: {
      return {
        ...state,
        loading_accounting_sales: action.payload.loading ?? state.loading_accounting_sales,
        accounting_sales: action.payload.items ?? state.accounting_sales,
        totals_accounting_sales: action.payload.totals ?? state.totals_accounting_sales,
      }
    }
    case Actions.GET_SALE_BY_ID: {
      return {
        ...state,
        loading_sale: action.payload.loading ?? state.loading_sale,
        sale: action.payload.data ?? state.sale,
      }
    }
    case Actions.RESET_SALE_BY_ID: {
      return { ...state, sale: null }
    }
    case Actions.SAVE_SALE: {
      const saveData = action.payload.data ? {
        ...action.payload.data,
        tiene_tickets: action.payload.data.tickets?.length > 0,
      } : null
      return {
        ...state,
        saving_sale: action.payload.saving ?? state.saving_sale,
        saved_sale: action.payload.saved ?? false,
        saved_sale_data: action.payload.data ?? null,
        sales: saveData
          ? addOrUpdateObjectInArray(state.sales, saveData, 'facturacion_id', true)
          : state.sales,
      }
    }
    case Actions.UPDATE_SALE: {
      return {
        ...state,
        updating_sale: action.payload.updating ?? state.updating_sale,
        updated_sale: action.payload.updated ?? false,
        sales: action.payload.data
          ? addOrUpdateObjectInArray(state.sales, action.payload.data, 'facturacion_id')
          : state.sales,
      }
    }
    case Actions.FINISH_SALE: {
      const finishData = action.payload.data ? {
        ...action.payload.data,
        tiene_tickets: action.payload.data.tickets?.length > 0,
      } : null
      return {
        ...state,
        finishing_sale_ids: toggleIdInArray(state.finishing_sale_ids, action.payload.finishing_id),
        finished_sale_ids: toggleIdInArray(state.finished_sale_ids, action.payload.finished_id),
        sales: finishData
          ? addOrUpdateObjectInArray(state.sales, finishData, 'facturacion_id')
          : state.sales,
        saved_sale_data: action.payload.data ?? state.saved_sale_data,
      }
    }
    case Actions.VOID_SALE: {
      return {
        ...state,
        voiding_sale_ids: toggleIdInArray(state.voiding_sale_ids, action.payload.voiding_id),
        voided_sale_ids: toggleIdInArray(state.voided_sale_ids, action.payload.finished_id),
        sales: action.payload.data
          ? addOrUpdateObjectInArray(state.sales, action.payload.data, 'facturacion_id')
          : state.sales,
      }
    }
    case Actions.SAVE_PRE_SALE_AS_ORDER_OR_PROFORMA: {
      return {
        ...state,
        saving_pre_sale_as_order_or_proforma: action.payload.saving ?? state.saving_pre_sale_as_order_or_proforma,
        saved_pre_sale_as_order_or_proforma: action.payload.saved ?? false,
      }
    }

    case Actions.GET_SALES_BY_SELLER: {
      return {
        ...state,
        loading_sales_by_seller: action.payload.loading,
        sales_headers_by_seller: action.payload.ventas ?? state.sales_headers_by_seller,
        sales_items_by_seller: action.payload.items ?? state.sales_items_by_seller,
        quantity_sales_headers_by_seller: action.payload.cantidad_ventas ?? state.quantity_sales_headers_by_seller,
        quantity_sales_items_by_seller: action.payload.cantidad_items ?? state.quantity_sales_items_by_seller,
        amount_sales_headers_by_seller: action.payload.total_ventas ?? state.amount_sales_headers_by_seller,
        amount_sales_items_by_seller: action.payload.total_items ?? state.amount_sales_items_by_seller,
      }
    }

    case Actions.DOWNLOADING_SALES_BY_SELLER: {
      return {
        ...state,
        downloading_sales_by_seller: action.payload,
      }
    }

    case Actions.GET_SALE: {
      return {
        ...state,
        loading_sale: action.payload.loading,
        sale: action.payload.data,
      }
    }

    case Actions.GET_PRICE_DOLLAR_SALES: {
      return {
        ...state,
        price_dollar: action.payload,
      }
    }

    case Actions.GET_DATA_COIN_TYPE: {
      return {
        ...state,
        coin_types: action.payload,
      }
    }

    case Actions.GET_DATA_CORRELATIVE_SERIES_VOUCHER: {
      return {
        ...state,
        correlativo: action.payload[0],
      }
    }

    case Actions.GET_DATA_SERIES_VOUCHER: {
      return {
        ...state,
        series: action.payload
      }
    }

    case Actions.GET_DATA_TYPE_PAYMENT: {
      return {
        ...state,
        types_payments: action.payload
      }
    }

    case Actions.GET_DATA_TYPE_PAYMENT_FROMS: {
      return {
        ...state,
        payment_forms: action.payload
      }
    }

    default: {
      return state
    }
  }
}

export default salesReducer